<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item,index) in levelList" :key="item.path">
        <span v-if="item.redirect==='noRedirect'||index==levelList.length-1" class="no-redirect">{{ item.meta.title }}</span>
        <a v-else @click.prevent="handleLink(item)">{{ item.meta.title }}</a>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
import { localRead } from '@/utils/tools'
import pathToRegexp from 'path-to-regexp'

export default {
  data() {
    return {
      levelList: null
    }
  },
  watch: {
    $route(to, from) {
      this.getBreadcrumb(from)
    }
  },
  created() {
    this.getBreadcrumb()
  },
  methods: {
    getBreadcrumb(from) {
      // only show routes with meta.title
      let matched = this.$route.matched.filter(item => item.meta && item.meta.title)
      //删除掉 菜单里面的菜单和公共两项
      matched.splice(0,1)
      matched.splice(0,1)
      const first = matched[0]
      if (!this.isDashboard(first)) {
        matched = [{ path: '/Layout?label='+this.$route.query.label, meta: { title: 'Dashboard' }}].concat(matched)
      }

      this.levelList = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false)
      // for(let i in this.levelList){
      //   if(this.levelList[i].path.split("?")[0] != ""){
      //     if(from == "" || from == undefined){
      //       this.levelList[i].path = this.levelList[i].path.split("?")[0] + "?label=" + localRead('breadLabel');
      //     }else{
      //       this.levelList[i].path = this.levelList[i].path.split("?")[0] + "?label=" + from.query.label
      //     }
          
      //   }else{
      //     this.levelList[i].path = this.levelList[i].path + "?label=" + from.query.label
      //   }
        
      // }
    },
    isDashboard(route) {
      const name = route && route.name
      if (!name) {
        return false
      }
      return name.trim().toLocaleLowerCase() === 'Dashboard'.toLocaleLowerCase()
    },
    pathCompile(path) {
      // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
      const { params } = this.$route
      var toPath = pathToRegexp.compile(path)
      return toPath(params)
    },
    handleLink(item) {
      const { redirect, path } = item
      if (redirect) {
        this.$router.push(redirect)
        return
      }
      this.$router.push(this.pathCompile(path))
    }
  }
}
</script>

<style lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 8px;

  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}
</style>
